import React, { useContext } from 'react';

import { AppContext } from '@prisjakt/ui-app-context';

import Clickable from '@prisjakt/ui-clickable';
import {
  CaptionText,
  Behavior,
  FontEmphasis,
} from '@prisjakt/ui/text/variants';
import ExpertAvatar from '../expert-avatar';

import * as S from './styles';

type Props = {
  className?: string;
  experts: Expert[];
  subtitle?: string | React.ReactNode;
};

type Expert = {
  avatar: string;
  name: string;
  url?: string;
};

function ExpertUserCard({ className, experts, subtitle }: Props) {
  const { t, renderMode, linkTo } = useContext(AppContext);

  const container = experts.length === 1 ? Clickable : 'div';
  const containerProps =
    experts.length === 1
      ? {
          to: linkTo(
            'expertProfile',
            { semantic_id: experts[0].url },
            renderMode === 'native' ? { view: 'native' } : undefined
          ),
          isExternal: renderMode === 'native',
        }
      : undefined;

  return (
    <S.Container className={className} as={container} {...containerProps}>
      {experts.map((expert, index) => (
        <S.Expert
          key={expert.name}
          $overlap={index}
          $index={experts.length - index}
        >
          <S.Avatar>
            <ExpertAvatar
              avatar={expert.avatar}
              displayName={expert.name}
              size={S.USER_AVATAR_SIZE}
            />
          </S.Avatar>

          {experts.length === 1 && (
            <>
              <S.Name
                behavior={Behavior.Oneline}
                showSubtitle={Boolean(subtitle)}
              >
                {expert.name}
              </S.Name>

              {subtitle && (
                <CaptionText emphasis={FontEmphasis.MEDIUM}>
                  {subtitle}
                </CaptionText>
              )}
            </>
          )}

          {experts.length > 1 && index === experts.length - 1 && (
            <S.Name showSubtitle={false} behavior={Behavior.Oneline}>
              {t('expert', 'guide.lists-expert-plural', {
                count: experts.length,
              })}
            </S.Name>
          )}
        </S.Expert>
      ))}
    </S.Container>
  );
}

export default ExpertUserCard;
